import { redirectTo } from 'helpers/path';
import { SEARCH_PATH } from 'features/Search/Search.route.path';

export default () => {
  const redirectToSearch = (nextState, replaceState, cb) => {
    const url = `${nextState.location.pathname}${nextState.location.search}`;
    const nextPath = url.replace(/^\/explore/, SEARCH_PATH);

    return redirectTo(nextPath)(nextState, replaceState, cb);
  };

  return {
    path: '/explore',

    onEnter: redirectToSearch,
    indexRoute: { onEnter: redirectToSearch },
    childRoutes: [{ path: '*', onEnter: redirectToSearch }],
  };
};
